import Swiper, { Autoplay, EffectCards, EffectFade, Pagination, Navigation } from 'swiper';

Swiper.use([Autoplay, EffectCards, EffectFade, Pagination, Navigation]);

(($) => {

  let GUID = 0;

  function buildSwiper(index, el) {
    let $target = $(el);

    // if ($.type(method) === 'object' || !method) {

      if ($.type($target.data('swiper-data')) === 'undefined') {

        // Fetch Inline Options

        let options = $target.data('swiper-options') || {};

        // Setup Data

        GUID++;

        let id = $target.attr('id') || 'swiper-' + GUID;

        let data = {
          GUID: GUID,
          id: id,
          selector: '#' + id,
          $el: $target,
          $items: $target.children(),
        };

        let defaults = {
          centerInsufficientSlides: true,
          grabCursor: true,
          labels: {
            previous: 'Previous',
            next: 'Next',
          },
          onAny: () => {
            // Alias swiper events to jquery
            if (typeof arguments[1].el !== 'undefined') {
              let event = arguments[0];
              let data = $(arguments[1].el).data('swiper-data');
              let args = Array.prototype.slice.call(arguments, 2);

              // if (typeof data !== 'undefined') {
              data.$el.trigger(event + '.swiper', args);
              // }
            }
          },
        };

        options = $.extend({}, defaults, options);

        // Restructure DOM

        data.$el.attr('id', id).addClass('swiper').wrapInner('<div class="swiper-wrapper"></div>');
        data.$items.addClass('swiper-slide');

        let html = '';

        if ($.type(options.navigation) !== 'undefined' && options.navigation !== false) {
          html += '<div class="swiper-navigation">';
          html += '<span class="swiper-button-prev swiper-control swiper-previous">' + options.labels.previous + '</span>';
          html += '<span class="swiper-button-next swiper-control swiper-next">' + options.labels.next + '</span>';
          html += '</div>';

          options.navigation = {
            nextEl: data.selector + ' .swiper-button-next',
            prevEl: data.selector + ' .swiper-button-prev',
          };
        }

        if ($.type(options.pagination) !== 'undefined' && options.pagination !== false) {
          html += '<div class="swiper-pagination"></div>';

          if ($.type(options.pagination) !== 'object') {
            options.pagination = {};
          }

          options.pagination.el = data.selector + ' .swiper-pagination';
          options.pagination.clickable = true;
        }

        if ($.type(options.scrollbar) !== 'undefined' && options.scrollbar !== false) {
          html += '<div class="swiper-scrollbar"></div>';

          if ($.type(options.scrollbar) !== 'object') {
            options.scrollbar = {};
          }

          options.scrollbar.el = data.selector + ' .swiper-scrollbar';
          options.scrollbar.clickable = true;
        }

        data.$el.attr('id', data.id).append(html);

        // Store Data

        data.$el.data('swiper-data', data);

        // Create Swiper Instance

        // console.log(data.$el);
        data.Swiper = new Swiper(data.$el.get(0), options);
      }
    // }

    return this;
  }

  $.fn['swiper'] = function() {
    return $(this).each(buildSwiper);
  };

// })(jQuery);

// (($) => {

  Formstone.Ready(() => {
    $('.js-swiper').swiper();
  });

})(jQuery);